import { NetworkStatus } from '@apollo/client'

// more info about network status values
// https://www.apollographql.com/docs/react/api/react/hoc/#datanetworkstatus
//
// this func do not show loader for polling requests
// thanks to this, polling can happen in the background
export const isLoadingData = (networkStatus: NetworkStatus) => [1, 2, 3, 4].some(v => networkStatus === v)
